import styled, { css, keyframes } from "styled-components";

interface MapContainerProps {
  showSpinner: boolean;
}

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const MapContainer = styled.div<{ showSpinner: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #aad3df;

  ${({ showSpinner }) =>
    showSpinner &&
    css`
      :after {
        content: "";
        box-sizing: border-box;
        position: absolute;
        top: 50%;
        left: 50%;
        width: 40px;
        height: 40px;
        margin-top: -20px;
        margin-left: -20px;
        border-radius: 50%;
        border: 5px solid rgba(180, 180, 180, 0.6);
        border-top-color: rgba(0, 0, 0, 0.6);
        animation: ${spin} 0.6s linear infinite;
      }
    `}
`;

export default MapContainer;
